var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"90%","height":"560px"},attrs:{"src":"https://www.jincheng.website/pdfweb/web.pdf"}})])
}]

export { render, staticRenderFns }